// add this to the window, to use as a global
window.loadEGScript = () => {
    // make sure we only run once.
    if ( true === window.isEGScriptLoaded ) {
        return;
    }

    window.isEGScriptLoaded = true;

    const egScript = window.document.createElement("script");
    egScript.setAttribute("type", "text/javascript");
    egScript.setAttribute("async", "true");
    egScript.setAttribute(
        "src",
        "https://sdk.classy.org/embedded-giving.js"
    );

    window.document.body.appendChild(egScript);

    window.egScriptLoaded = true;

    return new Promise((res, rej) => {
        egScript.onload = function () {
            res();
        };
        egScript.onerror = function () {
            rej();
        };
    });
}
